import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { AuthProvider } from "./store/AuthContext";
import { TenantProvider } from './store/TenantContext';
import { initSecurity, initRightClickProtection, initScreenshotProtection } from "./utils/security";
import { initializeNotifications } from "./utils/notifications";

// Initialize security measures before rendering
initSecurity();
initRightClickProtection();
// Screenshot protection disabled per user request
// initScreenshotProtection();

// Register service worker for offline caching and PWA features
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });

      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available - dispatch custom event for UpdatePrompt
              console.log('[App] New version available');
              window.dispatchEvent(
                new CustomEvent('sw-update-available', {
                  detail: { worker: registration.waiting },
                })
              );
            }
          });
        }
      });

      // Also check if there\'s already a waiting worker on load
      if (registration.waiting) {
        window.dispatchEvent(
          new CustomEvent('sw-update-available', {
            detail: { worker: registration.waiting },
          })
        );
      }

      console.log('[App] Service worker registered');
    } catch (error) {
      console.error('[App] Service worker registration failed:', error);
    }
  }
};

// Register SW after page loads to not block initial render
window.addEventListener('load', () => {
  registerServiceWorker();
  // Initialize push notification system
  initializeNotifications().then(({ supported, permission }) => {
    console.log('[App] Notifications initialized:', { supported, permission });
  });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <TenantProvider>
        <App />
      </TenantProvider>
    </AuthProvider>
  </StrictMode>
);
